import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import {PowerSelect} from 'react-power-select';

const CustomOptionComponent = ({ option }) => (
<div>
  <strong>{option.company.short_name}</strong> - <span>{option.name}</span>
</div>
);

export default class CustomersPowerSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      text: props.initialValue || 'placeholder',
      customers: props.customersAll || [],
      defaultValue: props.defaultValue || '',
      selectedOption: props.selectedOption || null,
      url: "/api/v1/portal/customers/all/for-dropdown-menu",
      jobId:props.jobId || '',
      selectedCustomer:props.selectedCustomer || null,
      selectedCustomerId:props.selectedCustomerId || null,
    };
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    return fetch(this.state.url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer ' + window.api_token
        , "Accept": 'application/json'
      },
    }).then((responseText) => {
      let response = responseText.json();
      response.then((response) => {
        this.setState({
          customers: response,
          isLoading: false
        });
        this.getDefaultCustomer();
      });
    });
    
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.selectedCustomerId !== nextProps.selectedCustomerId) {
      this.setState({
        selectedCustomerId: nextProps.selectedCustomerId,
        selectedOption: nextProps.selectedOption
      });
    }
  }

  getDefaultCustomer() {
    if(this.state.jobId && this.state.selectedCustomer){
      this.setState({
        selectedOption: this.state.selectedCustomer,
      });
      this.props.handleCustomerSelection(this.state.selectedCustomer);
    }
    if(this.state.selectedCustomerId){
      let UpdateJobFindex = this.state.customers.findIndex(customer => customer.id == this.state.selectedCustomerId);
      if(UpdateJobFindex != -1){
        this.setState({
          selectedOption: this.state.customers[UpdateJobFindex],
        });
        this.props.handleCustomerSelection(this.state.customers[UpdateJobFindex]);
      }
    }
  }

  handleChange( { option })  {
    this.setState({
      selectedOption: option
    })
    this.props.handleCustomerSelection(option);
  }

  render() {
    return (
      <PowerSelect
        options={this.state.customers}
        optionLabelPath="name"
        selected={this.state.selectedOption}
        selectedOption={this.state.selectedOption}
        onChange={this.handleChange}
        placeholder="-- select a Customer -- "
        optionComponent={<CustomOptionComponent />}
        required
        />
    )
  }
}
